import { faCopy, faEdit, faEye, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Chip, Paper, Stack, Tooltip, Typography } from "@mui/material";
import dayjs from "dayjs";
import DOMPurify from "dompurify";


export const myOwnFPColor = "#7fc3e5"
export const activeToggleColor = "#34046a"
export const iconSize = "lg"
export const exportColor = "#f46543"
export const adobeColor = "#e60f0f"
export const docColor = "#9f8315"
export const closeColor = "#C41E3A"
export const helpColor = "#17be34"
export const ideaColor = "#e2e200"
export const newsColor = "#C41E3A"
export const creditsRemainingColor = "#af3501"
export const deleteColor = "lightgrey"
export const quickColor = myOwnFPColor
export const starterColor = helpColor
export const offColor = "#fc0000"
export const onColor = "#008000"
export const defaultColor = "#d3d3d3"





export const gridColor = myOwnFPColor
export const chevronColor = myOwnFPColor



export const CheckboxRenderer = (props) => {
  const checkedHandler = (e) => {
    if (props.colDef.editable) {
      let checked = e.target.checked;
      let colId = props.column.colId;
      props.node.setDataValue(colId, checked);
    }
  };
  return (
    <center>
      <input
        type="checkbox"
        onChange={checkedHandler}
        checked={props.value ? props.value : false}
      />
    </center>
  );
};

const maxScenarioComparisons = 6

export const CheckboxCompareRenderer = (props) => {

  const checkedHandler = (e) => {

    if (props.colDef.editable) {
      let colId = props.column.colId
      console.log(colId)
      let c = props.value !== undefined ? Number(props.value) : 0

      if (c !== 0) {
        props.node.setDataValue(colId, 0);
        props.api.forEachNode(function (rowNode, index) {
          let v = rowNode.data.Compare !== undefined ? Number(rowNode.data.Compare) : 0
          if (v > c) {
            rowNode.setDataValue(colId, v - 1);
          }
        })
      }
      else {
        let max = 0
        props.api.forEachNode(function (rowNode, index) {
          let v = rowNode.data.Compare !== undefined ? Number(rowNode.data.Compare) : 0
          if (v > max) {
            max = v
          }
        })
        if (max < maxScenarioComparisons) { // if we want more adjust this
          props.node.setDataValue(colId, max + 1);
        }
      }
    }
  }

  return (
    <center>
      {((props.value === undefined || Number(props.value) === 0) &&
        <input
          type="checkbox"
          onChange={checkedHandler}
          checked={false}
        />
      )}
      {((props.value !== undefined && Number(props.value) !== 0) &&
        <Chip
          onClick={checkedHandler}
          //editable={false}
          label={props.value}
        />

      )}
    </center>
  );
};

export const WhoWhenRenderer = (props) => {

  //const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
  const cellValue = props.value;

  let td = ""
  // console.log(cellValue.When)
  // console.log(cellValue.Who)
  // console.log(props.valueFormatted)
  // console.log(props.value)


  if (cellValue.When !== '0001-01-01T00:00:00Z') {
    let d = new dayjs(cellValue.When);
    td = d.format("D-MMM-YYYY") + "  " + d.format("H:mm");
  }
  let name = cellValue.Who;
  let combo = td + "    " + name
  // return (
  //   <div>
  //     {td}
  //     <br />
  //     {name}
  //   </div>
  // );

  return (<div>{combo}</div>)
};

export const NameSpouseRenderer = (props) => {
  let n = props.data.FullName;
  if (props.data.Spouse !== "") {
    n += ", " + props.data.Spouse;
  }
  return n;
};


export const ScenarioIconRenderer = (props) => {
  return (
    <div>
      {props.value && (
        <FontAwesomeIcon
          icon={faEye}
          size={iconSize}
          //className="App-icon"
          color="blue"
          onClick={() => {
            props.callback("go-scenario");
          }}
        ></FontAwesomeIcon>
      )}
    </div>
  );
};
export const ViewIconRenderer = (props) => {
  return (
    <div>
      {props.value && (
        <FontAwesomeIcon
          icon={faEye}
          size={iconSize}
          //className="App-icon"
          color="blue"
          onClick={() => {
            props.callback("go-view");
          }}
        ></FontAwesomeIcon>
      )}
    </div>
  );
};

export const EditIconRenderer = (props) => {
  return (
    <div>
      {props.value && (
        <FontAwesomeIcon
          icon={faEdit}
          color="blue"
          size={iconSize}
          //className="mr-4 App-icon"
          onClick={() => {
            props.callback("go-edit");
          }}
        ></FontAwesomeIcon>
      )}
    </div>
  );
};
export const DeleteIconRenderer = (props) => {
  return (
    <div>
      <Tooltip>
        <FontAwesomeIcon
          icon={faTrashAlt}
          size={iconSize}
          //className="App-icon"
          color="black"
          onClick={() => {
            props.callback("go-delete");
          }}
        />
      </Tooltip>
    </div>
  );
};

export const CopyIconRenderer = (props) => {
  return (
    <div>
      {props.value && (
        <Tooltip>
          <FontAwesomeIcon
            icon={faCopy}
            size={iconSize}
            //className="App-icon"
            color="blue"
            onClick={() => {
              props.callback("go-copy");
            }}
          />
        </Tooltip>
      )}
    </div>
  );
};

const replaceWithBr = (c) => {
  let x = c.replace(/\n/g, "<br />")
  return x
}



export const gridTooltipRenderer = (props) => {
  // console.log(props)
  return (
    <div className="custom-tooltip">
      {props.value && (
        <Box>
          <Stack sx={{ mt: -1.5 }} direction="row" spacing={2}>
            <Paper elevation={2} sx={{ backgroundColor: "#eff3e5", }}>
              <Typography sx={{ m: 2, minWidth: 100, maxWidth: 1600 }} align="left" color="red"
                variant="body2"
              >
                <span
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.value) }}
                />
              </Typography>
            </Paper>
          </Stack>
        </Box>
      )}
    </div>
  );
};